"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsortedMechanics = exports.groupdMechanics = void 0;
var groupdMechanics = function (types, mechanics) {
    return types.map(function (type) {
        // Фильтруем механики по типу
        var mechanicsByType = mechanics.filter(function (mech) { return mech.type_id === type.id; });
        return { type: type, mechanics: mechanicsByType };
    });
};
exports.groupdMechanics = groupdMechanics;
var unsortedMechanics = function (types, mechanics) {
    return mechanics.filter(function (mech) {
        return !mech.type_id ||
            !types.some(function (type) { return type.id === mech.type_id; });
    });
};
exports.unsortedMechanics = unsortedMechanics;
